import { useEffect } from "react";
import { toast } from "sonner";
import { CHARACTERS } from "@/game/config";
import { useAuth } from "@/auth";
import { useLang } from "@/i18n";

const SEEN_KEY = "nicabros_unlocked_chars";

// Celebrate the moment a player's invite count crosses a character's lock tier.
// Invites are refreshed from the backend on every app load, so this fires when a
// player returns after friends have signed up — once per character per device,
// turning the referral reward into a shareable surprise.
export function useUnlockToast() {
  const { user } = useAuth();
  const { t } = useLang();

  useEffect(() => {
    if (!user) return;
    const invites = user.invites || 0;

    let seen;
    try { seen = new Set(JSON.parse(localStorage.getItem(SEEN_KEY) || "[]")); }
    catch { seen = new Set(); }

    const newlyUnlocked = CHARACTERS.filter(
      (c) => c.lockTier && invites >= c.lockTier && !seen.has(c.id)
    );
    if (newlyUnlocked.length === 0) return;

    newlyUnlocked.forEach((c) => seen.add(c.id));
    localStorage.setItem(SEEN_KEY, JSON.stringify([...seen]));

    newlyUnlocked.forEach((c, i) => {
      setTimeout(() => {
        toast.success(t("charUnlocked")(c.name), {
          description: t("charUnlockedDesc"),
          duration: 6000,
        });
      }, 1200 + i * 900);
    });
  }, [user, t]);
}
